<template>
    <svg
        viewBox="0 0 24 24"
        class="poi-icon"
        :class="`poi-icon-${iconName}`"
        role="img"
    >
        <title>{{ name }}</title>
        <path :d="path" />
    </svg>
</template>

<script>
import icons from '../helpers/icons.json';

export default {
    props: {
        name: String,
    },
    computed: {
        iconName() {
            let localName = this.name;
            // Icon aliases
            if (localName === 'hotels') {
                localName = 'hotel';
            }
            if (localName === 'truck_wash') {
                localName = 'carwash';
            }
            if (localName === 'fuel-stations') {
                localName = 'gas';
            }

            if (!icons[localName]) {
                localName = 'place'; // fallback
            }

            return localName;
        },
        path() {
            return icons[this.iconName];
        },
    },
};
</script>

<style scoped>
.poi-icon {
    fill: currentColor;
    vertical-align: middle;
    text-align: center;
}

.poi-icon-place {
    transform: translate(4px, 2px);
}
.poi-icon-parking {
    transform: translate(2px, 3px);
}
.poi-icon-carwash {
    transform: translate(1px, 2px);
}
.poi-icon-maintenance {
    transform: translate(2px, 2px);
}
.poi-icon-hotel {
    transform: translate(2px, 2px);
}
</style>
